<div class="nav-phone-call-banner-main-container">
    <div class="nav-phone-call-banner-headset-container">
        <i class="fas fa-headset nav-phone-call-banner-headset-icon"></i>
    </div>
    <div>
        ACTIVE PHONE CALL -&nbsp;
    </div>
    <div class="nav-phone-call-banner-participant-info">
        {{participantName | async}} {{employeeId | async}}
    </div>
</div>